import * as angular from 'angular';
import AdsBuyingView from './AdsBuyingView.html';
import { adsBuyingMfeScriptSource } from 'app.constants';
import { MicroFrontendService } from 'modules/shared/MicroFrontendService';
import { AdsBuyingController } from './AdsBuyingController';
import { AdsBuyingConstants } from './AdsBuyingConstants';
export const adsbuying = angular
    .module('adsbuying', ['ui.router'])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state(AdsBuyingConstants.ADS_BUYING_STATE, {
            url: '/adsbuying',
            views: {
                'content@auth.application.detail': {
                    template: AdsBuyingView,
                    controller: AdsBuyingController,
                    controllerAs: '$ctrl',
                },
            },
            onEnter: () => {
                MicroFrontendService.addSource(adsBuyingMfeScriptSource);
            },
        });
    }])
    .name;
